import { z } from "zod"
import { CreateMemberDtoSchema } from "@mimber/schema"

/**
 * Form schema for creating a managed member.
 * Re-exports the DTO schema from @mimber/schema.
 */
export const createMemberSchema = CreateMemberDtoSchema

export type CreateMemberFormData = z.output<typeof createMemberSchema>
